import { useContext, useEffect, useState } from "react";
import { CartContext } from "../../contexts/CartContext";
import { CurrencyContext } from "../../contexts/CurrencyContext";
import { errorMessage } from "../../api/global";
import { DISPLAY_LANG } from "../../config";

export default function CartDomains({ pagedata }) {
    const { orders, changeYearFromDomain, removeFromCart, cursorLoad } = useContext(CartContext);
    const { selectedCurrency } = useContext(CurrencyContext);

    const a = pagedata.registerDomainMessage[DISPLAY_LANG].split('/')[0];
    const b = pagedata.registerDomainMessage[DISPLAY_LANG].split('/')[1];

    const [openSelectId, setOpenSelectId] = useState(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!e.target.closest(".select")) {
                setOpenSelectId(null);
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    const handleRemoveDomainInCart = async (id) => {
        try {
            await removeFromCart(id);
        } catch (error) {
            console.log(error);
            alert(errorMessage[DISPLAY_LANG]);
        }
    };

    const handleChangeDomainYearInCart = async (id, year, domain_classKey) => {
        try {
            await changeYearFromDomain(id, year, domain_classKey);
        } catch (error) {
            console.log(error);
            alert(errorMessage[DISPLAY_LANG]);
        }
    };

    return orders.map((elem, index) => elem.item_type === 'domain' && (
        <div className='order flex-between' key={index}>
            <div className='left-side'>
                <h3>{elem.domain}</h3>

                <div
                    className={`select ${openSelectId === elem.id ? "open" : ""}`}
                    style={{ cursor: cursorLoad ? 'wait' : 'pointer' }}
                >
                    <p
                        className="selected-option"
                        onClick={() =>
                            setOpenSelectId(openSelectId === elem.id ? null : elem.id)
                        }
                        style={{ cursor: cursorLoad ? 'wait' : 'pointer' }}
                    >
                        {a} {elem.domain_number_of_years} {b}
                    </p>

                    <div className="dropdown">
                        {elem.domain_classKey === "dotru" ? [1].map(year => (
                            <p
                                key={year}
                                onClick={() => {
                                    handleChangeDomainYearInCart(elem.id, year, elem.domain_classKey);
                                    setOpenSelectId(null);
                                }}
                            >
                                {a} {year} {b}
                            </p>
                        )) : [1, 2, 3, 4, 5].map(year => (
                            <p
                                key={year}
                                onClick={() => {
                                    handleChangeDomainYearInCart(elem.id, year, elem.domain_classKey);
                                    setOpenSelectId(null);
                                }}
                            >
                                {a} {year} {b}
                            </p>
                        ))}
                    </div>
                </div>

            </div>

            <div className="right-side flex-center">
                {selectedCurrency.symbol === '$' && selectedCurrency.symbol + ' '}
                <div className='price'>{Math.ceil(elem.domain_price[selectedCurrency.title]).toFixed(2)}</div>
                {selectedCurrency.symbol !== '$' && ' ' + selectedCurrency.symbol}

                <img 
                  src="/images/domains/trash.svg" 
                  alt="trash" 
                  style={{ cursor: cursorLoad ? 'wait' : '' }} 
                  onClick={() => handleRemoveDomainInCart(elem.id)} 
                />
            </div>
        </div>
    ))
}
